import { useEffect, useRef } from 'react'
import styles from './StepIndicator.module.css'

interface StepIndicatorProps {
  steps: { id: number; title: string }[]
  currentStep: number
}

export const StepIndicator = ({ steps, currentStep }: StepIndicatorProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const stepRefs = useRef<(HTMLDivElement | null)[]>([])

  useEffect(() => {
    const currentStepIndex = steps.findIndex((step) => step.id === currentStep)
    const currentStepElement = stepRefs.current[currentStepIndex]

    if (currentStepElement && containerRef.current) {
      const container = containerRef.current
      const stepRect = currentStepElement.getBoundingClientRect()
      const containerRect = container.getBoundingClientRect()

      // Calculate the position to scroll to center the step
      const stepCenter = stepRect.left + stepRect.width / 2 - containerRect.left
      const containerCenter = container.offsetWidth / 2
      const scrollAmount = stepCenter - containerCenter

      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth',
      })
    }
  }, [currentStep, steps])

  return (
    <div ref={containerRef} className={styles.Container}>
      {steps.map((step, index) => (
        <div key={step.id} className={styles.StepWrapper}>
          <div
            ref={(el) => {
              stepRefs.current[index] = el
            }}
            className={styles.Step}
          >
            <span className={`${styles.StepNumber} ${currentStep === step.id ? styles.Active : ''}`}>{step.id}</span>
            <span className={`${styles.StepTitle} ${currentStep === step.id ? styles.ActiveStepTitle : ''}`}>{step.title}</span>
          </div>
          {index < steps.length - 1 && <div className={styles.Divider} />}
        </div>
      ))}
    </div>
  )
}
